import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import ProjectDetail from "./components/pages/ProjectDetail";
import SmoothScroll from "./components/layout/SmoothScroll";
import { PreloaderProvider } from "./context/PreloaderContext";
import { SectionProvider } from "./context/SectionContext";
import { GroundProvider } from "./context/GroundContext";
import { FilterProvider } from "./context/FilterContext";
import Boot from "./components/ui/Boot";
import Cursor from "./components/ui/Cursor";
import Hud from "./components/ui/Hud";

const Providers = ({ children }) => (
  <PreloaderProvider>
    <SectionProvider>
      <GroundProvider>
        <FilterProvider>{children}</FilterProvider>
      </GroundProvider>
    </SectionProvider>
  </PreloaderProvider>
);

const App = () => (
  <Providers>
    <SmoothScroll>
      <Router>
        <a className="skip-link" href="#main">
          Skip to content
        </a>

        <Boot />
        <Cursor />
        <Hud />

        <div id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>

        {/* Grain sits above content, below the cursor */}
        <div className="grain" aria-hidden="true" />
      </Router>
    </SmoothScroll>
  </Providers>
);

export default App;
